import React, { useEffect, useRef } from 'react';

type AnimatedIconHandle = {
  startAnimation: () => void;
  stopAnimation: () => void;
};

type AnimatedMenuIconProps = React.HTMLAttributes<HTMLDivElement> & {
  Icon: React.ElementType;
  active?: boolean;
  size?: number;
};

export default function AnimatedMenuIcon({
  Icon,
  active = false,
  className,
  onClick,
  size,
  ...props
}: AnimatedMenuIconProps) {
  const iconRef = useRef<AnimatedIconHandle>(null);

  useEffect(() => {
    if (active) {
      iconRef.current?.startAnimation();
      return;
    }

    iconRef.current?.stopAnimation();
  }, [active]);

  return (
    <Icon
      ref={iconRef}
      animateOnHover={false}
      aria-hidden="true"
      {...props}
      className={className}
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        iconRef.current?.startAnimation();
        onClick?.(event);
      }}
      size={size}
    />
  );
}
